import {Injectable} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ViewController {

  constructor(
    private modalCtrl: ModalController,
  ) {}

  async dismiss(data?, role?) {
    const top = await this.modalCtrl.getTop();

    try {
      if (top) {
        return await this.modalCtrl.dismiss(data, role);
      }
    } catch (error) {
      console.error('DISMISSED FAILED PST', error);
    }
    return null;
  }
}
